import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('product-reviews-count')
class ProductReviewsCount extends LitElement {
  @property({ type: Number, attribute: 'product-id' })
  accessor productId;

  @property({ type: String, attribute: 'yotpo-api-key' })
  accessor yotpoApiKey;

  @property({ type: Number, attribute: 'review-count' })
  accessor reviewCount;

  static styles = css`
    span {
      font-size: 0.75rem;
      line-height: 1.6;
      letter-spacing: 0.1px;
      text-decoration-line: underline;
      cursor: pointer;
      --tw-text-opacity: 1;
      color: rgba(66, 62, 59, var(--tw-text-opacity, 1));
    }
  `;

  connectedCallback() {
    super.connectedCallback();
    this.fetchReviewCount();
  }

  fetchReviewCount = async () => {
    if (!this.yotpoApiKey) return;
    // eslint-disable-next-line max-len
    const baseUrl = `https://api.yotpo.com/products/${this.yotpoApiKey}/${this.productId}/bottomline`;
    const response = await fetch(baseUrl);
    const json = await response.json();
    this.reviewCount = json.response.bottomline.total_reviews;
  };

  render() {
    return html`
      <span class="body-3--underline text-text-subdued cursor-pointer">
        (${this.reviewCount} Reviews)
      </span>
    `;
  }
}

export default ProductReviewsCount;
